import * as yup from "yup";
import { ICreateInvitationCode } from "../../../interfaces-and-types";

export const createInvitationCodeSchema: yup.SchemaOf<ICreateInvitationCode> =
  yup
    .object({
      description: yup.string().required().max(250),
    })
    .required();
